import { Drawer } from 'antd'
import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const DrawerStyled = styled(Drawer)`
  .ant-drawer-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
  .ant-drawer-content,
  .ant-drawer-content-wrapper {
    border-radius: 20px 20px 0 0;
  }

  .drawer-description {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 0;
  }

  .drawer-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 1.5em;
  }

  .drawer-buttons {
    display: flex;
    justify-content: space-between;
    gap: 20px;

    button {
      width: 100%;
    }
  }
`
